import script from "./init.vue?vue&type=script&setup=true&lang=js"
export * from "./init.vue?vue&type=script&setup=true&lang=js"

import "./init.vue?vue&type=style&index=0&id=03ea1375&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ea1375"]])

export default __exports__